<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Manual Payment</p>
      </header>
      <app-addsessionmanualpayment [Session]="Session"></app-addsessionmanualpayment>
    </div>
</div>